import { Typography, TypographyProps } from "@material-ui/core";
import { GroupBase, GroupHeadingProps, components } from "react-select5";

export function GroupHeadingComponent<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(
  props: GroupHeadingProps<Option, IsMulti, Group> & {
    textVariant: TypographyProps["variant"];
  }
) {
  return (
    <components.GroupHeading {...props}>
      <Typography style={{ textTransform: "none" }} variant={props.textVariant}>
        {props.children}
      </Typography>
    </components.GroupHeading>
  );
}
